import * as React from 'react';
import { useAccessToken } from '~/AccessToken';
import { CustomReportsRequest, ReportsRequest, } from '~/Api/Report';
import { useApi } from '~/ApiHooks';
import { Initial } from '~/Result';
var DefaultState = {
    config: {
        contact: { supportEmail: '' },
    },
    customReports: new Initial(),
    reloadCustomReports: function () { return Promise.resolve(); },
    reports: new Initial(),
    systemModules: [],
};
var Context = React.createContext(DefaultState);
Context.displayName = 'Application.Context';
var defaultQuery = {
    archived: false,
    page: 1,
    perPage: 50,
};
export var Store = function (_a) {
    var _b, _c, _d;
    var config = _a.config, children = _a.children;
    var _e = useAccessToken(), result = _e[0], accessToken = _e[1];
    var _f = useApi(), loadReports = _f[0], reports = _f[1];
    var _g = useApi(), loadCustomReports = _g[0], customReports = _g[1];
    var query = React.useState(defaultQuery)[0];
    React.useEffect(function () {
        if (accessToken === null) {
            return undefined;
        }
        loadReports(new ReportsRequest());
        loadCustomReports(new CustomReportsRequest(query));
        return undefined;
    }, [accessToken, query]);
    var systemModules = (_d = (_c = (_b = result.value) === null || _b === void 0 ? void 0 : _b.subscription) === null || _c === void 0 ? void 0 : _c.systemModules) !== null && _d !== void 0 ? _d : [];
    var reloadCustomReports = React.useCallback(function () {
        return loadCustomReports(new CustomReportsRequest(query));
    }, [query]);
    var value = React.useMemo(function () { return ({
        config: config,
        customReports: customReports,
        reloadCustomReports: reloadCustomReports,
        reports: reports,
        systemModules: systemModules,
    }); }, [config, reports, customReports, systemModules, reloadCustomReports]);
    return <Context.Provider value={value}>{children}</Context.Provider>;
};
Store.displayName = 'Application.Store';
export var useStore = function () { return React.useContext(Context); };
